'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = require('lodash');

var _ = _interopRequireWildcard(_lodash);

var _isomorphicFormData = require('isomorphic-form-data');

var _isomorphicFormData2 = _interopRequireDefault(_isomorphicFormData);

var _body = require('./body');

var _body2 = _interopRequireDefault(_body);

var _headers = require('./headers');

var _headers2 = _interopRequireDefault(_headers);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 @module request
 */

var validMethods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];
var validModes = ['navigate', 'same-origin', 'no-cors', 'cors'];
var validCredentialsModes = ['omit', 'same-origin', 'include'];
var validCacheModes = ['default', 'no-store', 'reload', 'no-cache', 'force-cache'];
var defaultProperties = {
  credentialsMode: 'omit',
  method: 'GET',
  mode: 'cors',
  referrer: 'client',
  redirect: 'manual',
  cacheMode: 'default',
  timeout: 0
};

var getBody = function getBody(input, init) {

  if (input instanceof Request && !init.body) return input._bodyInit;

  return init.body;
};

var Request = function (_Body) {
  _inherits(Request, _Body);

  function Request(input) {
    var init = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    _classCallCheck(this, Request);

    var isInputRequestInstance = input instanceof Request;
    var body = getBody(input, init);
    var defaultHeaders = {
      'Content-Length': 0,
      'Accept': '*/*',
      'User-Agent': 'farfetched/' + _constants.VERSION,
      'Connection': 'keep-alive'
    };

    if (!isInputRequestInstance && !_.isString(input)) throw new TypeError('Invalid request input');

    if (isInputRequestInstance && input.bodyUsed) throw new TypeError('Request body already used');

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Request).call(this, body));

    if (isInputRequestInstance && !init.body) input.bodyUsed = true;

    if (_.isString(body)) defaultHeaders['Content-Length'] = body.length;

    if (body instanceof _isomorphicFormData2.default && typeof body.getLengthSync === 'function') defaultHeaders['Content-Length'] = body.getLengthSync();

    if (isInputRequestInstance && !init.headers) _this.headers = new _headers2.default(_.defaults(input.headers, defaultHeaders));

    if (init.headers) _this.headers = new _headers2.default(_.defaults(init.headers, defaultHeaders));

    if (!_.has(_this, 'headers')) _this.headers = new _headers2.default(defaultHeaders);

    if (_.isString(input)) _this.url = input;

    if (isInputRequestInstance) _.extend(_this, defaultProperties, _.pick(input, _.keys(defaultProperties).concat('url')));

    if (_.isString(input)) _.extend(_this, defaultProperties, _.pick(init, _.keys(defaultProperties)));

    _this.method = _this.method.toUpperCase();

    if (!_.includes(validMethods, _this.method)) throw new TypeError('Invalid http method');

    if (_.includes(['GET', 'HEAD'], _this.method) && !_.isEmpty(body)) throw new TypeError('Body not allowed for GET or HEAD requests');

    if (!_.includes(validModes, _this.mode)) throw new TypeError('Invalid request mode');

    if (!_.includes(validCredentialsModes, _this.credentialsMode)) throw new TypeError('Invalid request credentialsMode');

    if (!_.includes(validCacheModes, _this.cacheMode)) throw new TypeError('Invalid request cacheMode');

    return _this;
  }

  _createClass(Request, [{
    key: 'clone',
    value: function clone() {

      return new Request(this);
    }
  }]);

  return Request;
}(_body2.default);

exports.default = Request;